import React, { useEffect, useState } from 'react';
import { clearError } from "@mobile-dev/platform/common/redux/actions/CommonAction";
import { efsTcheckTransaction, efsTcheckFuelCardTransaction, fsEFSTchekPaymentAction } from "@mobile-dev/platform/common/redux/actions/EFSTcheckAction";
import { Alert } from "react-bootstrap";
import Tooltip from '@mui/material/Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { toast } from 'react-toastify';
import ReactTooltip from "react-tooltip";
import { AppConstatnt } from "../../../../../Utils/AppConstant";
import { currencyConvertor, getApplicationFlow, getCarrierEnteredMobileNumber, getTheme, isEclipseOpsTruck, showAlert } from '../../../../../Utils/Utility';
import ErrornDialog from "../../../../Common/ErrorDialog/ErrorDialog";
import LoaderButton from "../../../../Common/LoaderButton";
import TransactionDialog from "../../../../Common/TransactionDialog";
import BilledHeader from "../BilledHeader";
import { injectIntl } from 'react-intl';
import NumberFormat from 'react-number-format';
import moment from 'moment';


function EFS({ intl }) {

    const dispatch = useDispatch();
    const location = useLocation();
    const auth = useSelector(state => state.amplifyUser);
    const userData = auth.user.attributes;
    const id = location.state.id;
    const efsTransaction = useSelector(state => state.efsTcheck);
    const loads = useSelector(state => state.billed.billedPo.loads);
    const load = loads.find(load => load.load_id === id);
    const load_control_num = load?.load_control_num;
    const warehouse_id = load?.warehouse_id;

    const amount = location.state.amount;
    const originalAmount = location?.state?.originalAmount;
    const remainingAmount = location.state.remainingAmount;
    const bankName = location.state.bankName;
    const selection = location.state.selection;
    const paymentmethods = location.state.paymentmethods;
    const total_bill_amount = location.state.total_bill_amount;
    const [errorStatus, setErrorStatus] = useState('');
    const [moneyCode, setmoneyCode] = useState({ moneyCodeVal1: "", moneyCodeVal2: "" });
    const [show, setShow] = useState(false);
    const [togglebutton, setTogglebutton] = useState(false);
    const [notMoneyCode, setNotMoneyCode] = useState({
        card_number: '',
        exp_date: '',
        driver_number: '',
        unit_number: '',
        odometer: '',
        trip_number: '',
        trailer_number: '',
        po_number: ''
    })
    const themeStyle = getTheme() === AppConstatnt.theme.DARK ? 'light' : '';
    const [isDefault, setIsDefault] = useState(false);
    const [isFuelCard, setIsFuelCard] = useState(false);
    const [isValid, setValid] = useState(true);
    const { formatMessage } = intl;
    const serviceFee = location.state.serviceFee;
    let driver_phone = getApplicationFlow() === 'Carrier' ? getCarrierEnteredMobileNumber() : userData.phone_number;

    useEffect(() => {
        dispatch(clearError());
    }, []);

    useEffect(() => {
        /* if Money code(No) is selected then validation for moneycode */
        if (!isFuelCard && moneyCode.moneyCodeVal1 > 0) {
            setTogglebutton(true)
        }
        /* if fuel code(Yes) is selected then validation for fuel card */
        else if (isFuelCard) {
            setTogglebutton(true)
        }
        else {
            setTogglebutton(false)
        }
    }, [moneyCode, isFuelCard]);

    const onShowAlert = () => {
        setShow(true)
        window.setTimeout(() => {
            setShow(false)
            setIsDefault(false);
        }, 10000);

    }

    const handleFuelCard = (e) => {
        if (e.target.id === 'fuel-card') {
            setIsFuelCard(true);
        }
        else {
            setIsFuelCard(false);
        }
    }

    useEffect(() => {

        if (efsTransaction?.error?.response?.status === 400 && efsTransaction?.error?.response.data) {

            // switch (efsTransaction?.error?.response.data.response_reason) {
            //     case AppConstatnt.tcheck_error_code.AMOUNT_CODE_INVALID:
            //         setErrorStatus(AppConstatnt.tcheck_error_response.AMOUNTCODEINVALID);
            //         break;
            //     case AppConstatnt.tcheck_error_code.INVALID_MONEY_CODE:
            //         setErrorStatus(AppConstatnt.tcheck_error_response.INVALIDMONEYCODE);
            //         break;
            //     case AppConstatnt.tcheck_error_code.DUPLICATE_INVOICE:
            //         setErrorStatus(AppConstatnt.tcheck_error_response.DUPLICATEINVOICE);
            //         break;
            //     case AppConstatnt.tcheck_error_code.AMOUNT_EXCEEDS_BALANCE:
            //         setErrorStatus(AppConstatnt.tcheck_error_response.AMOUNTEXCEEDSBALANCE);
            //         break;
            //     case "UNKNOWN ERROR CODE 46":
            //         setErrorStatus(AppConstatnt.tcheck_error_response.CODE46);
            //         break;
            //     default:
            //         //setErrorStatus(efsTransaction?.error?.response.data.response_reason)
            //         setErrorStatus(formatMessage({ id: "app.error_content" }));
            //         setIsDefault(true);
            //         break;
            // }
            const responseReason = efsTransaction?.error?.response?.data?.response_reason

            if (responseReason && (responseReason.includes("LMPR NOT ALLOWED") || responseReason.includes("LMPR"))) {
                setErrorStatus("LMPR NOT ALLOWED - " + formatMessage({ id: "app.lmpr_not_allowed" }))
            } else {
                setErrorStatus(responseReason)
            }
            onShowAlert();
        }
        else {
            setShow(false);

        }
    }, [efsTransaction?.error?.response])


    const handleMoneyCodeChange = (e) => {
        setmoneyCode({
            ...moneyCode,
            [e.target.name]: e.target.value
        });
    }

    const handleNotMoneyCodeChange = (e, event) => {
        if (typeof (e) === 'string') {
            setNotMoneyCode({
                ...notMoneyCode,
                driver_number: e
            });
        } else {
            if (event) {
                const eve = event
                if (eve.event.target.name === 'card_number') {
                    setNotMoneyCode({
                        ...notMoneyCode,
                        [eve.event.target.name]: e.value
                    });
                } else {
                    setNotMoneyCode({
                        ...notMoneyCode,
                        [eve.event.target.name]: e.formattedValue
                    });
                }
            } else {
                setNotMoneyCode({
                    ...notMoneyCode,
                    [e.target.name]: e.target.value
                });
            }

        }
    }

    const handleSubmit = () => {
        if (!isFuelCard) {
            if (moneyCode.moneyCodeVal1.length === 10 || moneyCode.moneyCodeVal1.length === 12 || moneyCode.moneyCodeVal1.length === 19 || moneyCode.moneyCodeVal1.length === 21) {
                if (isEclipseOpsTruck(load)) {
                    const transactionData = {
                        recID: id,
                        transactionType: "TCH_MONEY_CODE",
                        paymentCode: moneyCode.moneyCodeVal1,
                        driverLastName: auth?.user?.attributes.family_name,
                        driverFirstName: auth?.user?.attributes.given_name,
                        carrierName: "",
                        fullAmount: amount,
                        driverPhoneNumber: driver_phone,
                        transactionDateTime: moment(),
                        timeZone: "UTC+6",
                        unitNum: null,
                        tripNum: null,
                        relaySiteId: warehouse_id,
                        tabletype: "eclipseOps",
                        serviceFee: serviceFee,
                        paymentType: selection,
                        user_number: driver_phone,
                        
                    }
                    dispatch(fsEFSTchekPaymentAction(transactionData))
                }else{
                const transactionRequest = {
                    amount: amount,
                    warehouse_id: warehouse_id,
                    load_id: id,
                    transaction_type: 'TCH_MONEY_CODE',
                    money_code: moneyCode.moneyCodeVal1

                }
                dispatch(efsTcheckTransaction(transactionRequest));
            }
            }
            else {
                showAlert(toast.TYPE.WARNING, formatMessage({ id: "app.efs_money_code_tooltip" }))
            }
        } else if (isFuelCard) {
            fuelCardTrans()

        }

    }

    const fuelCardTrans = () => {

        if (notMoneyCode.card_number.length) {
            if (isEclipseOpsTruck(load)) {
                const { driver_number, unit_number, odometer, trip_number, po_number, trailer_number, card_number } = notMoneyCode
                const transactionData = {
                    recID: id,
                    transactionType: "WEX_FUEL_CARD",
                    cardNumber: card_number,
                    driverLastName: auth?.user?.attributes.family_name,
                    driverFirstName: auth?.user?.attributes.given_name,
                    carrierName: "",
                    fullAmount: amount,
                    driver_num: driver_number,
                    transactionDateTime: moment(),
                    timeZone: "UTC+6",
                    unitNum: unit_number,
                    tripNum: trip_number,
                    relaySiteId: warehouse_id,
                    user_number: driver_phone,
                    odometer: odometer,
                    poNumber: po_number,
                    trailerNumber: trailer_number,
                    tabletype: "eclipseOps",
                    serviceFee: serviceFee,
                    paymentType: selection,
                }
                dispatch(fsEFSTchekPaymentAction(transactionData))

            } else {
                const data = {
                    ...notMoneyCode,
                    amount: amount,
                    warehouse_id: warehouse_id,
                    load_id: id,
                    load_control_num,
                    load_id: load.load_id
                }
                dispatch(efsTcheckFuelCardTransaction(data));
            }
        } else {
            showAlert(toast.TYPE.WARNING, formatMessage({ id: "app.efs_fuel_card_label" }))
        }
    }

    const handleEmail = () => {
        window.open(`mailto:support@freightsmith.net?subject=${load_control_num}&body=Body%20goes%20here`)
    }

    const handleValid = (value) => {
        setValid(value);
    }

    const getAmount = () => {
        if (isEclipseOpsTruck(load)) {
            return parseFloat(amount) - parseFloat(serviceFee)
        } else {
            return originalAmount
        }
    }

    return (
        <div className="content-page">
            <div className="content">
                <div className="contest_input_block">
                    <BilledHeader path={`/paymentconfirmation/${id}`} amount={getAmount()} remainingAmount={remainingAmount} selection={selection} total_bill_amount={total_bill_amount} paymentmethods={paymentmethods} />
                    <div className="container_block" style={{ padding: '40px' }}>
                        <div id="smartwizard" className="sw sw-theme-dots sw-justified">
                            <div className="row">
                                {show &&
                                    <div className="col-md-8">
                                        <Alert variant="danger" onClose={() => setShow(false)} dismissible >
                                            {isDefault ? <>{errorStatus}<input className="btn-bg-none text-primary" type="button" onClick={handleEmail} value="support@freightsmith.net"></input>{formatMessage({ id: "app.thank_you" })}</> : errorStatus}
                                        </Alert>
                                    </div>
                                }
                            </div>
                            <div className="tab-content custom-toolbar">
                                <section id="EFS_hide">
                                    <h4 className="mb-2 txtwhite">{formatMessage({ id: "app.efs_payment" })}</h4>
                                    <p>{formatMessage({ id: "app.efs_total_charges" })}     <strong
                                        className="remaining_amt">${currencyConvertor(amount)}</strong></p>
                                    <p className="mt-1">{formatMessage({ id: "app.efs_isFuelCard" })}</p>
                                    <div className="row">
                                        <div className="col-2">

                                            <div className="checkbox-circle">

                                                <label>
                                                    <input type="radio" name="fuel-card" className="fuel-card" id="fuel-card" value='Yes' onChange={handleFuelCard}
                                                        checked={isFuelCard ? true : false}
                                                    />Yes
                                                    <span className="checkmark"></span>
                                                </label>

                                            </div>

                                        </div>
                                        <div className="col-2">
                                            <div className="checkbox-circle">
                                                <label>
                                                    <input type="radio" name="fuel-card" className="express-code" id="express-code" value='No' onChange={handleFuelCard}
                                                        checked={isFuelCard ? false : true}
                                                    />No
                                                    <span className="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    {!isFuelCard &&
                                        <div className="row">
                                            <div className="col-5">
                                                <div className="form-group">
                                                    <label htmlFor="efsMoneycode" >Money Code</label>

                                                    <input type="text" name="moneyCodeVal1"
                                                        id="efsMoneycode" data-tip data-for='efsMoneycode'
                                                        className="form-control" placeholder="Money Code" onChange={handleMoneyCodeChange}

                                                    />
                                                    <ReactTooltip id='efsMoneycode' type={themeStyle}>
                                                        <span>Enter a valid money code of 10,12 or 19 characters.</span>
                                                    </ReactTooltip>
                                                </div>
                                            </div>

                                        </div>}
                                    {
                                        isFuelCard &&
                                        <div className="row">
                                            <div className="col-5">
                                                <div className="form-group">
                                                    <label htmlFor="fuelCard" className="required">{formatMessage({ id: "app.efs_fuel_card" })}</label>
                                                    {/* <Tooltip title={formatMessage({ id: "app.payment_code_efs_fuel_card_tooltip" }, { length: 24 })} enterTouchDelay={0} arrow> */}
                                                    <div>
                                                        <NumberFormat
                                                            className="form-control"
                                                            onValueChange={(e, source) => handleNotMoneyCodeChange(e, source)}
                                                            data-tip data-for='card_number'
                                                            id="card_number"
                                                            name="card_number"
                                                            allowNegative="false"
                                                            placeholder={formatMessage({ id: "app.efs_fuel_card_label" })}
                                                        />
                                                    </div>
                                                    {/* </Tooltip> */}


                                                </div>
                                                {/* <div className="form-group">
                                                    <label htmlFor="exp_date">{formatMessage({ id: "app.efs_fuel_card_expDate" })}</label>
                                                    <Tooltip title={formatMessage({ id: "app.efs_fuel_card_expDate_tooltip" })} enterTouchDelay={0} arrow>
                                                        <div>
                                                            <NumberFormat format="##/##"
                                                                className="form-control"
                                                                onValueChange={handleNotMoneyCodeChange}
                                                                data-tip data-for='exp_date'
                                                                id="exp_date"
                                                                name="exp_date"
                                                                placeholder={formatMessage({ id: "app.efs_fuel_card_expDate_placeholder" })}
                                                            />
                                                        </div>
                                                    </Tooltip>

                                                </div> */}
                                                <div className="form-group">
                                                    <label htmlFor="driver_number" >{formatMessage({ id: "app.efs_fuel_card_driver_number" })}</label>
                                                    <Tooltip title={formatMessage({ id: "app.efs_fuel_card_driver_number_tooltip" })} enterTouchDelay={0} arrow>
                                                        <input type="text" name="driver_number" id="driver_number" data-tip data-for='driver_number'
                                                            className="form-control" placeholder={formatMessage({ id: "app.efs_fuel_card_placeholder_if_applicable" })} onChange={handleNotMoneyCodeChange} />
                                                    </Tooltip>

                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="unit_number" >{formatMessage({ id: "app.efs_fuel_card_unit_number" })}</label>
                                                    <Tooltip title={formatMessage({ id: "app.efs_fuel_card_unit_number_tooltip" })} enterTouchDelay={0} arrow>
                                                        <input type="text" name="unit_number" id="unit_number" data-tip data-for='unit_number'
                                                            className="form-control" placeholder={formatMessage({ id: "app.efs_fuel_card_placeholder_if_applicable" })} onChange={handleNotMoneyCodeChange} />
                                                    </Tooltip>

                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="trip_number" >{formatMessage({ id: "app.efs_fuel_card_trip_number" })}</label>
                                                    <Tooltip title={formatMessage({ id: "app.efs_fuel_card_trip_number_tooltip" })} enterTouchDelay={0} arrow>
                                                        <input type="text" name="trip_number" id="trip_number" data-tip data-for='trip_number'
                                                            className="form-control" placeholder={formatMessage({ id: "app.efs_fuel_card_placeholder_if_applicable" })} onChange={handleNotMoneyCodeChange} />
                                                    </Tooltip>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="odometer" >{formatMessage({ id: "app.efs_fuel_card_odometer" })}</label>
                                                    <Tooltip title={formatMessage({ id: "app.efs_fuel_card_odometer_tooltip" })} enterTouchDelay={0} arrow>
                                                        <input type="text" name="odometer" id="odometer" data-tip data-for='odometer'
                                                            className="form-control" placeholder={formatMessage({ id: "app.efs_fuel_card_placeholder_if_applicable" })} onChange={handleNotMoneyCodeChange} />
                                                    </Tooltip>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="purchase_number" >{formatMessage({ id: "app.efs_fuel_card_purchase_number" })}</label>
                                                    <Tooltip title={formatMessage({ id: "app.efs_fuel_card_purchase_number_tooltip" })} enterTouchDelay={0} arrow>
                                                        <input type="text" name="purchase_number" id="purchase_number" data-tip data-for='purchase_number'
                                                            className="form-control" placeholder={formatMessage({ id: "app.efs_fuel_card_placeholder_if_applicable" })} onChange={handleNotMoneyCodeChange} />
                                                    </Tooltip>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="trailer_number" >{formatMessage({ id: "app.efs_fuel_card_trailer_number" })}</label>
                                                    <Tooltip title={formatMessage({ id: "app.efs_fuel_card_trailer_number_tooltip" })} enterTouchDelay={0} arrow>
                                                        <input type="text" name="trailer_number" id="trailer_number" data-tip data-for='trailer_number'
                                                            className="form-control" placeholder={formatMessage({ id: "app.efs_fuel_card_placeholder_if_applicable" })} onChange={handleNotMoneyCodeChange} />
                                                    </Tooltip>
                                                </div>
                                            </div>

                                        </div>
                                    }
                                    <div className="toolbar toolbar-bottom" role="toolbar" style={{ textAlign: "right" }}>
                                        <LoaderButton
                                            className="btn btn-chartreuse justify-content-center "
                                            name='Submit'
                                            onButtonClick={handleSubmit}
                                            valid={togglebutton}
                                            loading={efsTransaction?.loading}
                                        />
                                    </div>
                                    {(efsTransaction?.efsTcheckTransaction?.transaction_status || efsTransaction?.efsTcheckTransaction?.status === "closed") && <TransactionDialog
                                        transactionId={efsTransaction?.efsTcheckTransaction?.transaction_status}
                                        statusMessage='EFS Payment Submitted Successfully'
                                        open
                                        id={id}
                                        paymentType={AppConstatnt.EFS}
                                        message="View payment details"
                                        amount={amount}
                                        remainingAmount={remainingAmount}
                                        selection={selection}
                                        total_bill_amount={total_bill_amount}
                                    />}
                                </section>
                            </div>
                            {efsTransaction?.error && !errorStatus && <ErrornDialog
                                error="Sorry you are experiencing an unknown issue. For immediate assistance, please contact our Contact Support Center at (855)752-2878 to speak with an agent. Thank you."
                                open
                            />}

                        </div>

                    </div>
                </div>
            </div ></div >
    )
}

export default injectIntl(EFS);